module.exports = __webpack_public_path__ + "img/wallet-small.92a69d4e.svg";